const PERKS_PAYMENT_OPTIONS = Object.freeze({
    SINGLE: 'single',
    RECURRING: 'recurring',
});

module.exports = {
    PERKS_PAYMENT_OPTIONS,
};
